import { useLocale } from "next-intl";
import { isLanguageCode } from "@/utils/helpers";
import { LocaleType } from "@/hooks/locale/useChangeLocale/types";

export const useStrictLocale = (): LocaleType => {
  const locale = useLocale();
  return isLanguageCode(locale) ? locale : "en";
};
